
export async function sendVoucher(transactionId: string) {
  const bodyRequest = {
    transactionId: transactionId,
    action: 'notification',
    type: 'EMAIL_BUYER_PAYER'
  };

  const config: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(bodyRequest)
  };

  let requestUrl = `/api/v1/transactions/sendVoucher`;

  try {
    const response = await fetch(requestUrl, config);

    if (!response.ok) {
      const errorData = await response.text();
      return new Error(`Request failed: ${response.status} - ${errorData}`);
    }

  } catch (error) {
    console.error('Error sending voucher:', error);
    throw error;
  }
}